import React, { useEffect } from "react";
import { useVeltClient } from "../context";
export function useNotificationUtils() {
    var _a = React.useState(), notificationElement = _a[0], setNotificationElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || notificationElement)
            return;
        var loadedNotificationElement = client.getNotificationElement();
        setNotificationElement(loadedNotificationElement);
    }, [client, setNotificationElement, notificationElement]);
    return notificationElement;
}
export function useNotificationsData() {
    var notificationElement = useNotificationUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getNotificationsData))
            return;
        var subscription = notificationElement.getNotificationsData().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getNotificationsData]);
    return data;
}
export function useUnreadNotificationsCount() {
    var notificationElement = useNotificationUtils();
    var _a = React.useState({ forYou: null, all: null }), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getUnreadNotificationsCount))
            return;
        var subscription = notificationElement.getUnreadNotificationsCount().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getUnreadNotificationsCount]);
    return data;
}
export function useNotificationSettings() {
    var notificationElement = useNotificationUtils();
    var _a = React.useState(null), settings = _a[0], setSettings = _a[1];
    var _b = React.useState(undefined), settingsData = _b[0], setSettingsData = _b[1];
    var _c = React.useState(undefined), settingsInitialConfigData = _c[0], setSettingsInitialConfigData = _c[1];
    useEffect(function () {
        if ((notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.setSettingsInitialConfig) && settingsInitialConfigData) {
            notificationElement.setSettingsInitialConfig(settingsInitialConfigData);
        }
    }, [notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.setSettingsInitialConfig, settingsInitialConfigData]);
    useEffect(function () {
        if ((notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.setSettings) && settingsData) {
            notificationElement.setSettings(settingsData);
        }
    }, [notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.setSettings, settingsData]);
    useEffect(function () {
        var _a;
        if (!(notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getSettings))
            return;
        // Added this check to make is backward compatible with the old version of the SDK where getSettings() returns value instead of observable
        if (!((_a = notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getSettings()) === null || _a === void 0 ? void 0 : _a.subscribe))
            return;
        var subscription = notificationElement.getSettings().subscribe(function (res) {
            setSettings(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getSettings]);
    var setSettingsInitialConfigCallback = React.useCallback(function (settingsInitialConfig) {
        setSettingsInitialConfigData(settingsInitialConfig);
    }, []);
    var setSettingsCallback = React.useCallback(function (settings) {
        setSettingsData(settings);
    }, []);
    return {
        settings: settings,
        setSettings: setSettingsCallback,
        setSettingsInitialConfig: setSettingsInitialConfigCallback,
    };
}
